import { render, staticRenderFns } from "./PollEventChart.vue?vue&type=template&id=6c836957&scoped=true"
import script from "./PollEventChart.vue?vue&type=script&lang=js"
export * from "./PollEventChart.vue?vue&type=script&lang=js"
import style0 from "./PollEventChart.vue?vue&type=style&index=0&id=6c836957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c836957",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
